import axios from 'axios'
import { formatRouteTenantPath, getCurrentTenant } from '@/utils'
import router from '@/router'

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // Whatsapp Status
    updateWhatsappStatus({ commit }) {
      const endpoint = process.env.VUE_APP_API_BASE_URL + `/api/settings/whatsapp_status`
      axios.get(endpoint).then(response => {
        if (response.data.value === 'true') {
          commit('UPDATE_WHATSAPP_STATUS', true)
        } else {
          commit('UPDATE_WHATSAPP_STATUS', false)
          const currentPath = router.currentRoute.fullPath
          const chatPath = formatRouteTenantPath('/chat/attendance')
          const instancesPath = formatRouteTenantPath('/instances/list/choose-instance')

          if (currentPath === chatPath) {
            router.push(instancesPath)
          }
        }
      });
    },

    // Maintenance Status
    updateMaintenanceStatus({ commit }) {
      const endpoint = process.env.VUE_APP_API_BASE_URL + `/api/settings/maintenance_status`
      axios.get(endpoint).then(response => {
        if (response.data.value === 'true') {
          commit('UPDATE_MAINTENANCE_STATUS', true)

          const currentPath = router.currentRoute.fullPath
          const chatPath = formatRouteTenantPath('/chat/attendance')
          const instancesPath = formatRouteTenantPath('/instances/list/choose-instance')

          if (currentPath === chatPath) {
            router.push(instancesPath)
          }
        } else {
          commit('UPDATE_MAINTENANCE_STATUS', false)
        }
      }).catch(error => {
        commit('UPDATE_OFFLINE_PLATFORM', true)
        commit('UPDATE_MAINTENANCE_STATUS', true)
        const currentPath = router.currentRoute.fullPath
        const chatPath = formatRouteTenantPath('/chat/attendance')
        const instancesPath = formatRouteTenantPath('/instances/list/choose-instance')
        if (currentPath === chatPath) {
          router.push(instancesPath)
        }
      });
    },

    // Offline Platform
    updateOfflinePlatform({ commit }, payload){
      commit('UPDATE_OFFLINE_PLATFORM', payload);
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

      // ActiveChatUser
    activeInstance({ commit }, name) {
      commit('SET_ACTIVE_INSTANCE', name)
    },
    
    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },
    updateUserRole({ dispatch }, payload) {
      // Change client side
      payload.aclChangeRole(payload.userRole)

      // Make API call to server for changing role

      // Change userInfo in localStorage and store
      dispatch('updateUserInfo', {userRole: payload.userRole})
    },

    setShowLoadingOverlay({ commit }, payload) {
      commit('SET_SHOW_LOADING_OVERLAY', payload)
    },

    // socketConnectionCount
    socketConnectionCount({ commit }, name) {
        commit('SET_SOCKET_CONNECTION_COUNT', name)
    },
}

export default actions
